import { Icon, IconProps } from "../";

export const CommentTypingIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12C22 14.3 21.2 16.5 19.7 18.3L21.7 20.3L21.7852 20.3957C22.0976 20.7911 22.0692 21.3308 21.7 21.7C21.5 21.9 21.3 22 21 22H12L11.7212 21.9961C6.34875 21.8472 2 17.4068 2 12ZM7 12C7 12.6 7.4 13 8 13C8.6 13 9 12.6 9 12C9 11.4 8.6 11 8 11C7.4 11 7 11.4 7 12ZM12 13C11.4 13 11 12.6 11 12C11 11.4 11.4 11 12 11C12.6 11 13 11.4 13 12C13 12.6 12.6 13 12 13ZM15 12C15 12.6 15.4 13 16 13C16.6 13 17 12.6 17 12C17 11.4 16.6 11 16 11C15.4 11 15 11.4 15 12Z"
      />
    </Icon>
  );
};
